export enum TipoNotificacaoApp {
    CLIPPING = "CLIPPING"
}
